import React, {useCallback} from 'react';
import PropTypes from 'prop-types';

const withTextInput = (TextInputComponent) => {
   const InnerWithTextInput = (props) => {
      const handleChange = useCallback((event) => {
         if (event?.target?.value.length <= props.maxCharacters) {
            props.form.setFieldValue(props.field.name, event?.target?.value);
            if (props.setValue) {
               props.setValue(event?.target?.value);
            }
         }
      }, []);

      return (
         <TextInputComponent
            handleChange={handleChange}
            {...props.field}
            isDisabled={props.isDisabled}
            isTouched={props.form.touched[props.field.name]}
            errorMessage={props.errorMessage}
            type={props.type}
            appendText={props.appendText}
            onClick={props.onClick}
         />
      );
   };

   InnerWithTextInput.propTypes = {
      field: PropTypes.shape({
         name: PropTypes.string.isRequired,
         onChange: PropTypes.func.isRequired,
         onBlur: PropTypes.func.isRequired,
         value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }).isRequired,
      form: PropTypes.shape({
         touched: PropTypes.objectOf(PropTypes.any).isRequired,
      }).isRequired,
      isDisabled: PropTypes.bool,
      errorMessage: PropTypes.string,
      type: PropTypes.string,
      setValue: PropTypes.func,
      maxCharacters: PropTypes.number,
   };

   InnerWithTextInput.defaultProps = {
      isDisabled: false,
      errorMessage: undefined,
      type: 'text',
      setValue: null,
      maxCharacters: Infinity,
   };

   return InnerWithTextInput;
};

export default withTextInput;
